<form #accountForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/account_receipt']">Account Receipt</a> > {{ account_receipt.receipt_number }}</h3>
    </div>
    <div class="form-actions">
      <a *ngIf="account_receipt.id && isFormDisabled && !['cancelled'].includes(account_receipt.status)" target="_blank" href="/api/account_receipt/{{ account_receipt.id }}/download">
        <button type="button" mat-stroked-button><mat-icon>print</mat-icon> Print</button>
      </a>
      <ng-container *ngIf="!['submitted','canceled'].includes(account_receipt.status)">
        <button *ngIf="isFormDisabled && account_receipt.status == 'draft'" type="button" mat-flat-button color="primary" (click)="confirmDialog(account_receipt.id, 'submit')">
          <mat-icon>check_circle</mat-icon> Submit
        </button>
        <button *ngIf="isFormDisabled && account_receipt.status == 'draft'" type="button" mat-stroked-button color="warn" (click)="confirmDialog(account_receipt.id, 'cancel')">Cancel</button>
        <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(accountForm.valid)">
          <mat-icon>save</mat-icon> Save
        </button>
        <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
          <mat-icon>edit</mat-icon> Edit
        </button>
        <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
          <mat-icon>add</mat-icon> Create
        </button>
        <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
      </ng-container>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Receipt No.</mat-label>
            <input #receipt_number="ngModel" [disabled]="true" type="text" matInput name="receipt_number" [(ngModel)]="account_receipt.receipt_number" required>
            <mat-error *ngIf="receipt_number.invalid && receipt_number.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Receipt Date</mat-label>
            <input #date="ngModel" matInput [(ngModel)]="account_receipt.receipt_date" name="receipt_date" required [matDatepicker]="receipt_date" [min]="minDate" [max]="maxDate" required>
            <mat-datepicker-toggle matSuffix [for]="receipt_date">
              <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #receipt_date></mat-datepicker>
            <mat-error *ngIf="date.invalid && date.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Type</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selected_account_receipt_type">
              <input class="select-input" type="text" autocomplete="nope" matInput name="account_receipt_type">
              <mat-option *ngFor="let accountReceiptType of all_account_receipt_types" [value]="accountReceiptType">{{ accountReceiptType | titlecase }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Doctor Name</mat-label>
            <mat-select #doctor_id (openedChange)="onDoctorScroll($event)" [disabled]="isFormDisabled || disableDoctorSelection" [(value)]="selectedDoctor" (selectionChange)="onDoctorOrAccountChange()" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onDoctorKey($event)" matInput name="doctort_list">
              <mat-option *ngFor="let doctor of allDoctors" [value]="doctor.id">{{ doctor.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Company</mat-label>
            <mat-select #company_id (openedChange)="OnCompanyScroll($event)" [disabled]="isFormDisabled || disableCompanySelection" [(value)]="selectedCompany" (selectionChange)="onCompanyChange()" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="OnCompanyKey($event)" matInput name="company_list">
              <mat-option *ngFor="let company of allCompanies" [value]="company.id">{{ company.company_name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Account Name</mat-label>
            <mat-select #account_id (openedChange)="onAccountScroll($event)" [disabled]="isFormDisabled || disableAccountSelection" [(value)]="selectedAccount" (selectionChange)="onDoctorOrAccountChange()" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onAccountKey($event)" matInput name="account_list">
              <mat-option *ngFor="let account of allAccounts" [value]="account.id">{{ account.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Net Amount</mat-label>
            <input #net_amount="ngModel" type="number" matInput name="net_amount" [(ngModel)]="account_receipt.net_amount" (change)="calculateTotalAmount()" required>
            <mat-error *ngIf="net_amount.invalid && net_amount.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>TDS Amount</mat-label>
            <input #tds_amount="ngModel" type="number" matInput name="tds_amount" [(ngModel)]="account_receipt.tds_amount" (change)="calculateTotalAmount()" required>
            <mat-error *ngIf="tds_amount.invalid && tds_amount.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Total Amount</mat-label>
            <input #total_amount="ngModel" type="number" matInput name="total_amount" [(ngModel)]="account_receipt.total_amount" [disabled]="true" required>
            <mat-error *ngIf="total_amount.invalid && total_amount.touched">Required</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Narration</mat-label>
            <textarea #narration="ngModel" matInput name="narration" [(ngModel)]="account_receipt.narration"></textarea>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Reference No.</mat-label>
            <input #reference_number="ngModel" type="text" matInput name="reference_number" [(ngModel)]="account_receipt.reference_number">
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <div class="field-label">Balance</div>
          <p class="receipt-balance">{{ account_receipt.balance }}</p>
        </div>
      </div>

      <!-- Knock-Off Tab -->
      <mat-tab-group animationDuration="0ms" class="mt-4">
        <mat-tab id="knock_off_list" label="Knock-Off">
          <table mat-table [dataSource]="knockoffsDataSource" #knock_off_lines class="mat-elevation-z2 mt-3">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>Select</th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="toggleSelection(row)" [checked]="selection.isSelected(row)" [disabled]="isFormDisabled || (account_receipt.balance <= 0 && !selection.isSelected(row))"></mat-checkbox>
              </td>
            </ng-container>
            <ng-container class="mat-table-row" [matColumnDef]="column" *ngFor="let column of displayColumns; let i = index;">
              <th class="font-weight-bold" mat-header-cell *matHeaderCellDef>{{ displayHeaders[i] }}</th>
              <td mat-cell *matCellDef="let obj" class="header-cell">{{ obj[column] }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumnsWithSelect"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumnsWithSelect;"></tr>
          </table>
        </mat-tab>
      </mat-tab-group>
    </fieldset>
  </div>
  <app-audit-log-viewer model="account_receipt" [recordId]="account_receipt.id"></app-audit-log-viewer>
</form>
